// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { modalButtonsActionStyles, xScreen } from "@awc/XDL/Utilities";
import { defaultBillingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultBillingAddress";
import { css } from "styled-components";

defaultBillingAddressStyles.gridContainer = {
    gap: 0,
};

defaultBillingAddressStyles.editLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        weight: fontConfig.weight.bold,
        css: css`
            line-height: ${fontConfig.lineHeight.singleLineRegular};
        `,
    },
};

defaultBillingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        align-items: baseline;
        gap: 24px;
        ${xScreen("lte", "xs")} {
            justify-content: space-between;
        }
    `,
};

defaultBillingAddressStyles.headingText = {
    variant: "h4",
    as: "h3",
};

defaultBillingAddressStyles.customerSelectorModal = {
    cssOverrides: {
        modalContent: css`
            overflow-x: hidden;
        `,
    },
};

defaultBillingAddressStyles.customerSelectorModalButtonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

defaultBillingAddressStyles.customerSelectorModalCancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

defaultBillingAddressStyles.addressInfoDisplayGridItem = {
    width: 12,
    css: css`
        margin-top: 8px;
    `,
};
